import { useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";

import S from "./CodeViewModal.module.scss";

const CodeViewModal = ({ visible, onHide, code, languageLabel, submittedAt }) => {
  const [isMaximized, setIsMaximized] = useState(false);

  const handleCopyCode = () => {
    if (code) {
      navigator.clipboard.writeText(code);
    }
  };

  const formatSubmissionDate = date => {
    if (!date) return "";
    const submissionDate = new Date(date);
    return submissionDate.toLocaleString([], {
      month: "short",
      day: "numeric",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const headerTemplate = () => {
    return (
      <div className={S.customHeader}>
        <div className={S.headerText}>
          <span className={S.headerTitle}>{`Submitted ${languageLabel} Code`}</span>
          {submittedAt && (
            <span className={S.headerSubtitle}>{formatSubmissionDate(submittedAt)}</span>
          )}
        </div>
        <Button
          icon="pi pi-copy"
          rounded
          text
          severity="secondary"
          onClick={handleCopyCode}
          tooltip="Copy code to clipboard"
          aria-label="Copy code to clipboard"
          tooltipOptions={{ position: "bottom" }}
          className="mr-2"
        />
      </div>
    );
  };

  return (
    <Dialog
      header={headerTemplate}
      visible={visible}
      onHide={onHide}
      style={{ width: "70vw" }}
      maximizable
      modal
      contentClassName={S.dialogContent}
      headerClassName={S.dialogHeader}
      maskClassName={S.blurredMask}
      onMaximize={e => setIsMaximized(e.maximized)}
      maximized={isMaximized}
      pt={{
        maximizableButton: {
          className: "mr-2",
          "aria-label": isMaximized ? "Restore" : "Maximize",
        },
      }}
    >
      <div className={S.codeViewContainer}>
        <pre className="atlas-code p-4 max-h-60vh overflow-auto">
          <code>{code || "No code available"}</code>
        </pre>
      </div>
    </Dialog>
  );
};

export default CodeViewModal;
